export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    type: 'checkbox',
    align: 'center',
    fixed: 'left',
    width: 50,
  },
  {
    width: 50,
    align: 'center',
    slots: {
      default: 'opt1',
    },
    titleHelp: {message: '按住后拖拽，可调整中转顺序！'},
  },
  {
    field: 'transferStationCode',
    headerAlign: 'center',
    align: 'left',
    width: 150,
    title: '中转站',
    editRender: {
      name: 'dict-select',
      props: {
        size: 'mini',
        default: false,
        clearable: true,
        filterable: true,
        placeholder: '请选择中转站',
        url: '/master/transfer/station/select',
      },
    },
    showOverflow: 'ellipsis',
  },
  {
    field: 'transportMode',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    title: '运输模式',
    editRender: {
      name: 'dict-select',
      props: {
        size: 'mini',
        default: true,
        clearable: true,
        filterable: true,
        body: {type: 'transportMode'},
      },
    },
    showOverflow: 'ellipsis',
  },
  {
    field: 'bizType',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    title: '业务类型',
    editRender: {
      name: 'dict-select',
      props: {
        size: 'mini',
        default: true,
        clearable: true,
        filterable: true,
        body: {type: 'bizType'},
      },
    },
    showOverflow: 'ellipsis',
  },
  {
    field: 'uploadReceiptFlag',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    title: '是否上传回单',
    editRender: {
      name: 'select',
      options: [
        {label: '需要上传', value: 'Y'},
        {label: '不需要上传', value: 'N'},
      ],
    },
  },
  {
    field: 'receiveDatetimeBegin',
    align: 'center',
    width: 192,
    title: '预计最早到达时间',
    editRender: {
      name: 'date-picker',
      props: {
        size: 'mini',
        type: 'datetime',
        placeholder: '请选择预计最早到达时间',
        valueFormat: 'yyyy-MM-dd HH:mm:ss',
      },
    },
    showOverflow: 'ellipsis',
  },
  {
    field: 'receiveDatetimeEnd',
    align: 'center',
    width: 192,
    title: '预计最晚到达时间',
    editRender: {
      name: 'date-picker',
      props: {
        size: 'mini',
        type: 'datetime',
        placeholder: '请选择预计最晚到达时间',
        valueFormat: 'yyyy-MM-dd HH:mm:ss',
      },
    },
    showOverflow: 'ellipsis',
  },
  {
    field: 'outDatetimeBegin',
    align: 'center',
    width: 192,
    title: '预计最早发出时间',
    editRender: {
      name: 'date-picker',
      props: {
        size: 'mini',
        type: 'datetime',
        placeholder: '请选择预计最早发出时间',
        valueFormat: 'yyyy-MM-dd HH:mm:ss',
      },
    },
    showOverflow: 'ellipsis',
  },
  {
    field: 'outDatetimeEnd',
    align: 'center',
    width: 192,
    title: '预计最晚发出时间',
    editRender: {
      name: 'date-picker',
      props: {
        size: 'mini',
        type: 'datetime',
        placeholder: '请选择预计最晚发出时间',
        valueFormat: 'yyyy-MM-dd HH:mm:ss',
      },
    },
    showOverflow: 'ellipsis',
  },
  {
    field: 'orgCode',
    align: 'center',
    width: 200,
    title: '子单组织机构',
    editRender: {
      name: 'dict-select',
      props: {
        size: 'mini',
        default: false,
        clearable: true,
        filterable: true,
        placeholder: '请选择组织机构',
        url: '/sys/organization/dict/select',
      },
    },
    showOverflow: 'ellipsis',
  },
]
